<template lang="pug">
  Modal(ref="modal" title="Recall Code" closable="true")
    .recall-code-body.ssp-form-horizontal
      form
        .form-group
          label.ic-label Description
          .ic-control
            input.form-control(v-model="description" placeholder="Description")
    div(slot="footer")
      button.btn.btn-primary.go-to-button(@click="recallCode()" :disabled="!isValid") Recall Code
      button.btn.btn-default(@click="$refs.modal.cancel()") Cancel
</template>

<script>
import miniToastr from 'mini-toastr'
import Modal from '@/components/common/Modal'
import TrackNTrace from '@/service/apis/TrackNTrace'

export default {
  props: {
    code: {
      type: String,
      required: true
    }
  },
  data: () => ({
    description: null
  }),
  methods: {
    recallCode() {
      const req = {
        codes: [this.code],
        description: this.description
      }
      TrackNTrace.recallCode(req)
        .then(() => {
          miniToastr.success(`${this.code} recalled`)
        })
    },
    open() {
      this.$refs.modal.open();
    }
  },
  computed: {
    isValid() {
      return this.orderId !== ''
    }
  },
  components: {
    Modal
  }
}
</script>
<style lang="scss">
.recall-code-body {
  width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/trackntrace/dashboards/trace/components/RecallCodeModal.vue